import api from "./api";

export const HelpdeskBrandingAPI = {
  async listProfiles() {
    return api("/helpdesk/brand-profiles");
  },

  async getProfile(id) {
    return api(`/helpdesk/brand-profiles/${id}`);
  },

  async getResolvedProfile(schoolId = null) {
    const url = schoolId
      ? `/helpdesk/brand-profiles/resolved?school_id=${schoolId}`
      : `/helpdesk/brand-profiles/resolved`;

    return api(url);
  },

  async saveProfile(payload) {
    return api("/helpdesk/brand-profiles", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  async assignSchools(profileId, schoolIds) {
    return api(`/helpdesk/brand-profiles/${profileId}/schools`, {
      method: "PUT",
      body: JSON.stringify({ school_ids: schoolIds }),
    });
  },
};